export const downloadUrl = (url: string): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.onload = () => resolve(xhr.response)
    xhr.onerror = (event) => reject(event)
    xhr.open('GET', url)
    xhr.send()
  })
}
